<template>
    <div
      class="hoax-page"
      :style="hoaxPageStyle">
      <v-layout wrap>
        <v-flex>
          <section class="hoax-section">
            <div>
              <!-- <v-card
                v-if="process.load"
                flat
                height="250"
                width="100vw"
                color="#00000040">
                <v-skeleton-loader
                  :loading="process.load"
                  transition="scale-transition"
                  :tile="false"
                  class="ma-auto load_card_x_large"
                  type="image"
                  style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
                </v-skeleton-loader>
              </v-card> -->
              <div v-if="!process.load">
                  <!-- <v-card
                    flat
                    cover
                    v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' "
                    class="background-default">
                    <img :src="require('@/assets/image/Candi-Prambanan.jpg')" style="width: 100%; height: 250px; opacity: 0.75;" class="img_center align-center">
  
                      <div class="d-flex align-center justify-center font-weight-black">
                        <div class="text-center">
                          <div
                            class="text-h4 white--text justify-center mb-2 pt-6"
                            style="font-weight: 500;">
                            {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Rumah Hoax dan Insiden Siber</span>
                          </div>
  
                          <div
                            class="body-1 white--text text-center mb-4"
                            style="opacity: 50%; font-weight: 500;">
                            Mengenal {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Rumah Hoax dan Insiden Siber</span> di kabupaten Klaten.
                          </div>
                        </div>
                      </div>
  
                    </img>
                  </v-card> -->
              </div>
            </div>
            <v-container :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'px-0' : ''">
              <!-- Hero (desktop) -->
              <v-row v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'" class="hoax-hero-row">
                <v-col cols="12" class="hoax-hero-col">
                  <div class="hoax-hero" :style="{ '--hoax-hero-bg': set_color, '--hoax-hero-dark': set_color_dark }">
                    <div class="hoax-hero-inner">
                      <div class="hoax-hero-text">
                        <h1 class="hoax-hero-title">Rumah Hoax dan Insiden Siber</h1>
                        <p class="hoax-hero-subtitle">Informasi hoax beredar dan insiden siber di Kabupaten Klaten</p>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <div>
                <v-row>
                  <v-col cols="12" md="9" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pt-0' : ''">
                    <!-- Mobile header -->
                    <div v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'" class="hoax-mobile-header mb-4">
                      <h1 class="hoax-mobile-title">Rumah Hoax dan Insiden Siber</h1>
                      <div class="hoax-mobile-actions">
                        <v-autocomplete
                          v-model="filter.category"
                          :items="category"
                          item-text="category_title"
                          item-value="id"
                          hide-no-data
                          hide-details
                          dense
                          solo
                          single-line
                          placeholder="Pilih Kategori"
                          :color="set_color"
                          @change="changeQuery(category.find(item => item.id === filter.category)?.category_name); selected.category = category.findIndex(c => c.id === filter.category); if (selected.category < 0) selected.category = 0; currentPage = 1; fetch()"
                          class="hoax-mobile-select"
                          append-icon="mdi-chevron-down">
                        </v-autocomplete>
                      </div>
                    </div>
                    <v-row>
                      <v-col
                        v-for="(item, index) in process.load || process.list ? 8 : list"
                        :key="index"
                        :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 6 : 12"
                        md="4">
                        <v-skeleton-loader
                          :loading="process.load || process.list"
                          transition="scale-transition"
                          :tile="false"
                          class="ma-auto"
                          type="card">
                          <div>
                            <div v-if="!process.list && !process.load && list.length > 0"
                              class="hoax-card-wrap">
                              <v-card
                                :to="`/rumah-hoax-dan-insiden-siber/${item.slug}?q=${item.id}`"
                                @mouseover="voiceHover(item.title)"
                                class="hoax-card"
                                width="100%">
                                <div class="hoax-card-image-wrap">
                                  <img
                                    :style="`height: ${$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 130 : 200}px;`"
                                    alt="Pemerintah Kabupaten Klaten"
                                    :src="item.image_url_cover === '' ? item.image_url === '' ? require('@/assets/image/no-photo.png') : item.image_url : item.image_url_cover"
                                    class="hoax-card-image"
                                    @contextmenu.stop>
                                </div>

                                <div class="pa-3 hoax-card-body">
                                  <div class="hoax-card-title" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-2 one-line' : 'fs-12 two-line'">
                                    {{ item.title }}
                                  </div>

                                  <div class="d-flex align-center mt-1 hoax-card-meta">
                                    <v-icon small class="hoax-card-meta-icon">mdi-account-circle-outline</v-icon>
                                    <span class="fs-11 one-line ml-1">Admin</span>
                                  </div>

                                  <div class="fs-11 font-weight-light three-line my-2 hoax-card-excerpt">
                                    <span v-html="item.content.replace(/(<([^>]+)>)/ig, '')"></span>
                                  </div>

                                  <v-divider class="hoax-card-divider my-2" />

                                  <div class="fs-11 d-flex align-center hoax-card-date">
                                    <v-icon x-small class="mr-1" style="opacity: 0.8;">mdi-calendar-outline</v-icon>
                                    {{ item.publish_datetime | date }}
                                  </div>
                                </div>
                              </v-card>
                            </div>
                          </div>
                        </v-skeleton-loader>
                      </v-col>
                    </v-row>
                    <div v-if="!process.load && pagination.total_data > pageSize"
                      class="hoax-pagination mt-4 mb-2">
                      <div class="hoax-pagination-inner">
                        <div class="body-2 hoax-pagination-info">
                          Total seluruh data: {{ (pagination.total_data || 0).toLocaleString('id-ID') }}
                        </div>
                        <v-pagination
                          v-model="currentPage"
                          :length="totalPages"
                          :total-visible="$vuetify.breakpoint.smAndDown ? 5 : 7"
                          :color="set_color"
                          circle
                          prev-icon="mdi-chevron-left"
                          next-icon="mdi-chevron-right"
                          class="hoax-pagination-control"
                          @input="onPageChange"
                        />
                      </div>
                    </div>
  
                    <Empty v-if="!process.load && pagination.total_page < 1"
                      class="py-12"
                      margin="my-16"
                      size="125"
                      message="Rumah Hoax dan Insiden Siber" />
  
                  </v-col>
                  <v-col cols="12" md="3" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                    <v-card flat class="hoax-sidebar-card mb-6 mt-0">
                      <v-card-text class="hoax-sidebar-content">
                        <div class="hoax-sidebar-title" :style="{ color: set_color }">
                          <v-icon small class="mr-1">mdi-folder-outline</v-icon>
                          Kategori
                        </div>
                        <v-divider class="hoax-sidebar-divider mb-0 mt-2"></v-divider>
                        <div v-for="(item, index) in process.load ? 8 : category" :key="index">
                          <v-skeleton-loader
                            class="ma-auto"
                            :loading="process.load"
                            type="list-item-three-line">
                            <div>
                              <div v-if="!process.load && category.length > 0" @mouseover="voiceHover(item.category_title)">
                                <v-list one-line class="py-0">
                                  <v-list-item class="hoax-category-item px-0" :class="{ 'hoax-category-item--active': selected.category === index }" @click="selected.category = index; changeQuery(item.category_name); filter.category = item.id || ''; currentPage = 1; fetch()">
                                    <v-list-item-content class="py-2" :style="selected.category === index ? { color: set_color } : {}">
                                      <v-list-item-title class="hoax-category-label">{{ item.category_title }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="my-0" v-if="selected.category === index">
                                      <v-icon x-small :color="set_color">mdi-chevron-right</v-icon>
                                    </v-list-item-action>
                                  </v-list-item>
                                </v-list>
                                <v-divider
                                  v-if="index < category.length - 1"
                                ></v-divider>
                              </div>
                            </div>
                          </v-skeleton-loader>
                        </div>
                      </v-card-text>
                    </v-card>

                    <Sidebar />
                  </v-col>
                </v-row>
              </div>
  
  
            </v-container>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { createSEOMeta } from '@/utils/seo'
    export default {
      middleware: false,
      data () {
        return {
          search: '',
          category: [],
          selected: {
            category: 0
          },
          filter: {
            category: ''
          },
          total_category: 0,
          list: [],
          pagination: {},
          currentPage: 1,
          pageSize: 12,
          process: {
            load: false,
            list: false
          },
          message: {
            success: '',
            error: ''
          },
          // SEO
          content: {
            url: '/rumah-hoax-dan-insiden-siber',
            title: 'Rumah Hoax dan Insiden Siber',
            description: 'Rumah Hoax dan Insiden Siber Kabupaten Klaten',
            image: require('@/assets/logo/favicon.png')
          }
        }
      },
      head () {
        return {
          title: this.content.title,
          meta: createSEOMeta(this.content)
        }
      },
      // components: {
      //   Utama: () => import(/* webpackPrefetch: true */ '@/components/berita/utama.vue'),
      //   OPD: () => import(/* webpackPrefetch: true */ '@/components/berita/opd.vue'),
      //   Wilayah: () => import(/* webpackPrefetch: true */ '@/components/berita/wilayah.vue'),
      // },
      components: {
        Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
        Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
      },
      watch: {
        '$route.query.category': function (val) {
          this.changeLink(val)
        }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.member.auth.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.header.config.color
        },
        set_color_dark () {
          const hex = (this.$store.state.header.config.color || '#B71C1C').replace(/^#/, '')
          const r = Math.max(0, parseInt(hex.slice(0, 2), 16) * 0.65)
          const g = Math.max(0, parseInt(hex.slice(2, 4), 16) * 0.65)
          const b = Math.max(0, parseInt(hex.slice(4, 6), 16) * 0.65)
          return '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('')
        },
        hoaxPalette () {
          const primary = this.set_color || '#B71C1C'
          return {
            '--hoax-bg': '#FAF7F5',
            '--hoax-surface': '#FFFFFF',
            '--hoax-text': '#2D2D2D',
            '--hoax-text-muted': '#6B6B6B',
            '--hoax-border': '#E8E4E0',
            '--hoax-primary': primary,
            '--hoax-primary-soft': primary + '14',
            '--hoax-accent': '#B8860B',
            '--hoax-shadow': '0 2px 12px rgba(45, 45, 45, 0.06)',
            '--hoax-shadow-hover': '0 8px 24px rgba(45, 45, 45, 0.1)'
          }
        },
        hoaxPageStyle () {
          const isDesktop = this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm'
          const padding = isDesktop
            ? { paddingTop: '128px', paddingBottom: '280px' }
            : { paddingTop: '64px', paddingBottom: '650px' }
          return Object.assign({}, this.hoaxPalette, padding)
        },
        totalPages () {
          const total = this.pagination.total_page ?? Math.ceil((this.pagination.total_data || 0) / this.pageSize)
          return Math.max(1, total)
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchCategory()
      },
      methods: {
        voiceHover (item) {
          responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
          responsiveVoice.speak(item, 'Indonesian Female');
        },
        async fetchCategory (id, type) {
          this.process.load = type === undefined ? true : false
  
          let params = {
            limit: 1000000,
            par_id: '17'
          }
  
          await this.$axios.$get(`${process.env.API}sites/article/category`, { params })
          .then(response => {
            let res = response
  
            if (res.status === 200) {
              this.category = [
                {
                  category_title: "Semua Kategori",
                  category_icon_url: require('@/assets/icon/app.png'),
                  id: '',
                  category_name: "semua-kategori",
                  count: 0
                }
              ]
              let category = []
              category = res.results.data.map(item => {
                  const container = {};
  
                  container.category_title = item.title;
                  container.category_icon_url = item.icon_url;
                  container.id = item.id;
                  container.category_name = item.slug;
                  container.count = item.count
  
                  // this.category = container;
                  return container
                })
  
  
              for (let i in category) {
                this.category.push(
                  {
                    category_title: category[i].category_title,
                    category_icon_url: category[i].category_icon_url,
                    id: category[i].id,
                    category_name: category[i].category_name,
                    count: category[i].count
                  }
                )
  
              }
  
              for (let i in this.category) {
                this.total_category += parseInt(this.category[i].count)
  
              }
  
              this.process.load = false
              this.category[0].count = this.total_category
              this.changeLink()
            }
          })
        },
        onPageChange () {
          this.fetch()
          window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        async fetch () {
          this.process.list = true

          let params = this.filter.category === '' ? {
            'title[lse]': this.$route.query.search === undefined ? '' : this.$route.query.search,
            limit: this.pageSize,
            page: this.currentPage,
            category_par_id: '17',
            sort: '-publish_datetime'
          } : {
            'title[lse]': this.$route.query.search === undefined ? '' : this.$route.query.search,
            limit: this.pageSize,
            page: this.currentPage,
            sort: '-publish_datetime',
            category_id: this.filter.category
          }

          await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          .then(response => {
            let res = response

            if (res.status === 200) {
              this.list = res.results.data
              this.pagination = res.results.pagination
            }
            this.process.list = false
            this.process.load = false
          })
        },
        changeLink () {
        let status = false
        this.selected.category = 0
        this.filter.category = ''
        this.currentPage = 1
        if (this.$route.query.category !== undefined) {
          for (let i = 0; i < this.category.length; i++) {
            if (this.category[i].category_name === this.$route.query.category) {
              this.filter.category = this.category[i].id
              this.selected.category = i
              status = true
              break
            }
          }
        }
        if (status === false && this.category.length) {
          this.$router.replace(`/rumah-hoax-dan-insiden-siber?category=${this.category[0].category_name}`)
        }
        this.fetch()
      },
      changeQuery (name) {
        if (name === '' || !name) {
          this.$router.replace({ path: '/rumah-hoax-dan-insiden-siber' })
        } else {
          this.$router.replace({ path: '/rumah-hoax-dan-insiden-siber', query: { category: name } })
        }
      },
      toDetail (item) {
        this.$router.push(`/rumah-hoax-dan-insiden-siber/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      }
    }
    }
  </script>

  <style scoped>
  .hoax-page {
    background-color: var(--hoax-bg);
    min-height: 100vh;
    box-sizing: border-box;
  }

  .hoax-section {
    min-height: 0;
  }

  .hoax-hero-row {
    margin-bottom: 2rem;
  }

  .hoax-hero-col {
    padding-top: 0;
    padding-bottom: 0;
  }

  .hoax-hero {
    background: linear-gradient(135deg, var(--hoax-hero-bg) 0%, var(--hoax-hero-dark) 100%);
    border-radius: 16px;
    padding: 1.75rem 2rem;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  }

  .hoax-hero-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.5rem;
  }

  .hoax-hero-text {
    flex: 0 0 auto;
  }

  .hoax-hero-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: #fff;
    margin: 0 0 0.25rem 0;
    letter-spacing: -0.02em;
  }

  .hoax-hero-subtitle {
    font-size: 0.9375rem;
    color: rgba(255, 255, 255, 0.88);
    margin: 0;
  }

  .hoax-mobile-header {
    background: var(--hoax-surface);
    border-radius: 12px;
    padding: 1rem;
    box-shadow: var(--hoax-shadow);
    border: 1px solid var(--hoax-border);
  }

  .hoax-mobile-title {
    font-size: 1.375rem;
    font-weight: 700;
    color: var(--hoax-text);
    margin: 0 0 0.75rem 0;
  }

  .hoax-mobile-actions {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .hoax-mobile-select >>> .v-input__slot {
    border-radius: 10px;
    border: 1px solid var(--hoax-border);
  }

  /* ---- Cards ---- */
  .hoax-card-wrap {
    border-radius: 12px;
    overflow: hidden;
  }

  .hoax-card {
    border-radius: 12px !important;
    box-shadow: var(--hoax-shadow) !important;
    border: 1px solid var(--hoax-border);
    overflow: hidden;
    transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
  }

  .hoax-card:hover {
    box-shadow: var(--hoax-shadow-hover) !important;
    transform: translateY(-4px);
    border-color: var(--hoax-primary);
  }

  .hoax-card::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, var(--hoax-primary), var(--hoax-accent));
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
    border-radius: 12px 0 0 12px;
  }

  .hoax-card:hover::before {
    opacity: 1;
  }

  .hoax-card-image-wrap {
    overflow: hidden;
    border-radius: 12px 12px 0 0;
  }

  .hoax-card-image {
    width: 100%;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
    transition: transform 0.45s ease;
  }

  .hoax-card:hover .hoax-card-image {
    transform: scale(1.04);
  }

  .hoax-card-body {
    background: var(--hoax-surface);
  }

  .hoax-card-title {
    font-weight: 700;
    color: var(--hoax-text);
    line-height: 1.4;
    font-size: 0.9375rem;
  }

  .hoax-card-meta {
    color: var(--hoax-text-muted);
    font-size: 0.75rem;
  }

  .hoax-card-meta-icon {
    color: var(--hoax-primary) !important;
  }

  .hoax-card-excerpt {
    color: var(--hoax-text-muted);
    min-height: 47px;
    height: 47px;
    max-height: 47px;
    opacity: 0.9;
    font-size: 0.8125rem;
    line-height: 1.4;
  }

  .hoax-card-divider {
    border-color: var(--hoax-border) !important;
    opacity: 0.8;
  }

  .hoax-card-date {
    color: var(--hoax-text-muted);
    opacity: 0.9;
    font-size: 0.75rem;
  }

  /* ---- Sidebar ---- */
  .hoax-sidebar-card {
    border-radius: 12px !important;
    background: var(--hoax-surface) !important;
    border: 1px solid var(--hoax-border);
    box-shadow: var(--hoax-shadow);
  }

  .hoax-sidebar-content {
    padding: 1rem 1.25rem !important;
  }

  .hoax-sidebar-title {
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
  }

  .hoax-sidebar-divider {
    border-color: var(--hoax-border) !important;
  }

  .hoax-category-item {
    border-radius: 8px;
    transition: background 0.2s ease, color 0.2s ease;
    min-height: 44px;
  }

  .hoax-category-item:hover {
    background: var(--hoax-primary-soft) !important;
  }

  .hoax-category-item--active {
    background: var(--hoax-primary-soft) !important;
    font-weight: 600;
  }

  .hoax-category-label {
    font-size: 0.875rem !important;
  }

  .hoax-pagination {
    width: 100%;
  }

  .hoax-pagination-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem 1.25rem;
    background: var(--hoax-surface);
    border: 1px solid var(--hoax-border);
    border-radius: 12px;
    box-shadow: var(--hoax-shadow);
  }

  .hoax-pagination-info {
    color: var(--hoax-text-muted);
    font-size: 0.875rem;
  }

  .hoax-pagination-control.v-pagination {
    flex-wrap: wrap;
    justify-content: center;
  }

  .hoax-pagination-control.v-pagination .v-pagination__item,
  .hoax-pagination-control.v-pagination .v-pagination__navigation {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
    margin: 0 3px !important;
    font-weight: 600;
    font-size: 0.875rem;
    box-shadow: none;
    border: 1px solid var(--hoax-border);
  }

  .hoax-pagination-control.v-pagination .v-pagination__item--is-active {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }

  .hoax-pagination-control.v-pagination .v-pagination__more {
    margin: 0 2px;
    min-width: 28px;
  }

  @media (max-width: 600px) {
    .hoax-pagination-inner {
      flex-direction: column;
      align-items: stretch;
      text-align: center;
    }

    .hoax-pagination-control.v-pagination .v-pagination__item,
    .hoax-pagination-control.v-pagination .v-pagination__navigation {
      min-width: 32px !important;
      width: 32px !important;
      height: 32px !important;
    }
  }
  </style>
